/*jslint browser: true, devel:true */
/*global define*/

import config from './../store/index.js';

function lodeBetterImage(nodes) {
	if (nodes) {
		const img = new Image();

		img.src = `${config.assetPath}/${config.siteCode}/img/bg-footer.jpg`;

		img.addEventListener('load', () => {
			for (const node of nodes) {
				node.classList.add('blur-bg--no');
			}
		}, {
			once: true,
			passive: true
		});
	}
}
if(parseInt(config.siteId, 10) === 0) {
	const blurBgNodes = document.querySelectorAll('.blur-bg');
	lodeBetterImage(blurBgNodes);
}



// WEBPACK FOOTER //
// ./mobile-core/src/utils/background-blur.js